// React for Website

import React, { useState, useEffect } from "react";
//outsource
import { Row, Col, Radio, Form, Space, InputNumber, Select } from "antd";
import { ClockCircleOutlined } from "@ant-design/icons";

//components

const VoucherExpiry = ({ form }) => {
  // -------------------------- VAR --------------------------
  const options = [
    {
      label: "Months",
      value: "months",
    },
    { label: "Days", value: "days" },
    { label: "Years", value: "years" },
  ];
  // -------------------------- STATE --------------------------
  const [value, setValue] = useState("after");
  const [amount, setAmount] = useState(10);
  const [step, setStep] = useState("years");

  // -------------------------- REDUX --------------------------
  // -------------------------- FUNCTION -----------------------
  const onChange = (e) => {
    const value = e.target.value;
    setValue(value);
  };

  // -------------------------- EFFECT --------------------------
  useEffect(() => {
    const expiry = {
      amount,
      step,
    };
    form.setFieldsValue({ expiry });
  }, [form, amount, step]);

  useEffect(() => {
    if (value === "never") {
      const expiry = {
        amount: 3,
        step: "years",
      };
      form.setFieldsValue({ expiry });
    }

    if (value === "after") {
      setStep("years");
      setAmount(10);
      const expiry = {
        amount: 10,
        step: "years",
      };
      form.setFieldsValue({ expiry });
    }
  }, [value]);
  // -------------------------- RENDER --------------------------
  const renderRadioCheck = () => {
    // const disabled = value === "never" || false;
    const disabled = true;
    return (
      <Radio.Group
        style={{ width: "100%" }}
        onChange={onChange}
        value={value}
        disabled={true}
      >
        <Row style={{ alignItems: "center", width: "100%" }}>
          <Col lg={4} md={4} sm={4} xs={4}>
            <Radio value="never">Never</Radio>
          </Col>
          <Col lg={20} md={20} sm={20} xs={20}>
            <Space>
              <Radio value="after">After</Radio>
              <InputNumber
                style={{ width: 130 }}
                defaultValue={1}
                min={1}
                precision={0}
                addonBefore={<ClockCircleOutlined />}
                disabled={disabled}
                onChange={(value) => setAmount(value)}
                value={amount}
              />
              <Select
                disabled={disabled}
                defaultValue={"months"}
                options={options}
                onChange={(value) => setStep(value)}
                value={step}
              />
            </Space>
          </Col>
        </Row>
      </Radio.Group>
    );
  };

  // -------------------------- MAIN --------------------------
  return (
    <>
      <Form.Item name="expiry" label="Expiry Date"></Form.Item>
      <Col style={{ marginTop: -45 }}>{renderRadioCheck()}</Col>
    </>
  );
};

export default VoucherExpiry;
